import type { ErrorMessageType } from "@freightsimple/ui-core/FormLayout/FormItem";
import type { PreQuoteLocation } from "@freightsimple/generated-dashboard-openapi-client/models/PreQuoteLocation";
import { isSimilar } from "@/Helpers/isSimilar";
import { isStorageBrand } from "@/Helpers/isStorageBrand";

export function locationsErrorMessageForBusinessName(
  businessName: string | undefined,
  pickupLocation?: PreQuoteLocation,
  deliveryLocation?: PreQuoteLocation,
): ErrorMessageType {
  if (businessName === undefined || businessName === "") {
    return "Required";
  }

  if (businessName.length < 4) {
    return "Too short";
  }

  if (isStorageBrand(businessName)) {
    return "Storage facilities require special handling. Please contact support for assistance with storage location deliveries.";
  }

  // Check for duplicate business names with specific messages
  if (pickupLocation && isSimilar(businessName, pickupLocation.businessName)) {
    return "Should not match pickup details";
  }

  if (
    deliveryLocation &&
    isSimilar(businessName, deliveryLocation.businessName)
  ) {
    return "Should not match delivery details";
  }

  return undefined;
}
